import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
import 'bootstrap/dist/css/bootstrap.min.css';

import './index.css';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(HttpApi)
  .init({
    supportedLngs: ['en', 'he', 'ar'],
    fallbackLng: 'en',
    debug: false,
    detection: {
      order: ['path', 'querystring', 'cookie', 'navigator'],
      caches: ['cookie'],
    },
    backend: {
      loadPath: '/assets/locales/{{lng}}/translation.json',
    },
  });

ReactDOM.render(
  <Suspense fallback={<h3 className='py-4 text-center'>Loading..</h3>}>
    <AuthProvider>
      <App />
    </AuthProvider>
  </Suspense>,
  document.getElementById('root')
);
